import styled from 'styled-components';
import { black, lightGray, middleGray } from 'styles/colorProvider';

export const Container = styled.div`
  width: 100%;
  min-width: min(100%, 960px);
  min-height: 56px;
  display: grid;
  grid-template-columns: 44px minmax(100px, 1.2fr) minmax(90px, 1fr) 90px minmax(80px, 0.9fr) minmax(100px, 1.4fr) 110px 100px 44px 52px 72px;
  gap: 12px 16px;
  align-items: center;
  border: 1px solid ${lightGray};
  border-radius: 12px;
  margin-top: 10px;
  padding: 12px 16px;
  font-size: 13px;
  background: #fff;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    grid-template-columns: 40px minmax(90px, 1fr) minmax(80px, 0.9fr) 80px minmax(70px, 0.8fr) minmax(90px, 1.2fr) 100px 90px 40px 44px 64px;
    gap: 10px 12px;
    padding: 10px 12px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-flow: dense;
    gap: 8px 16px;
    padding: 16px;
    min-height: auto;

    .cell-icon {
      grid-column: 1;
      grid-row: 1;
      align-self: start;
    }
    .cell-cliente {
      grid-column: 2;
      grid-row: 1;
      align-self: start;
    }
    .cell-autor {
      grid-column: 1;
      grid-row: 2;
    }
    .cell-placa {
      grid-column: 2;
      grid-row: 2;
    }
    .cell-marca {
      grid-column: 1;
      grid-row: 3;
    }
    .cell-modelo {
      grid-column: 2;
      grid-row: 3;
    }
    .cell-valor {
      grid-column: 1;
      grid-row: 4;
    }
    .cell-criada {
      grid-column: 2;
      grid-row: 4;
    }
    .cell-farol {
      grid-column: 1;
      grid-row: 5;
    }
    .cell-dias {
      grid-column: 2;
      grid-row: 5;
    }
    .cell-actions {
      grid-column: 1 / -1;
      grid-row: 6;
      justify-self: end;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 4px;
      justify-content: flex-end;
    }
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.align === 'center' ? 'center' : 'flex-start')};
  justify-content: center;
  min-width: 0;

  @media (max-width: 900px) {
    align-items: flex-start;
  }
`;

export const CellContent = styled.div`
  min-width: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 900px) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 32px;
    height: 32px;
  }
`;

export const FarolIndicator = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(p) => p.color || middleGray};
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
  cursor: default;
  flex-shrink: 0;
`;

export const Title = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: ${black};
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 2px;

  @media (max-width: 900px) {
    font-size: 10px;
    margin-bottom: 0;
  }
`;

export const Subtitle = styled.span`
  display: block;
  font-size: 13px;
  color: ${middleGray};
  min-height: 20px;

  @media (max-width: 900px) {
    font-size: 12px;
  }
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  margin-left: 4%;
  width: 80%;

  @media (max-width: 1000px) {
    width: 80%;
    margin-bottom: 10px;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 25%;
  cursor: pointer;
  transition: all ease-in-out 0.3s;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;
